module.exports = __webpack_public_path__ + "static/media/annotationDone.6c1d10e2.png";